export default {
    path: "/workbench",
    redirect: "/workbench/home",
    meta: {
        title: "工作台",
        permissionCode: "pcWorkbench",
    },
    children: [
        {
            path: "home",
            meta: {
                title: "全部应用",
                permissionCode: "pcWorkbench",

            },
            component: () => import("@/views/workbench/home.vue"),
        },
        {
            path: "masterTask",
            meta: {
                title: "材料总计划",
                permissionCode: "pcWorkbenchMaterPlan",
                name: "workbenchMaterPlan",
                keepAlive: true
            },
            component: () => import("@/views/workbench/masterTask/list.vue"),
        },
        {
            path: "branchTask",
            meta: {
                title: "材料分批计划",
                permissionCode: "pcWorkbenchBatchPlan",
                name: "workbenchBatchPlan",
                keepAlive: true
            },
            component: () => import("@/views/workbench/branchTask/list.vue"),
        },
        {
            path: "purchase",
            meta: {
                title: "采购管理",
                permissionCode: "pcWorkbenchPurchase",
                name: "workbenchPurchase",
                keepAlive: true
            },
            component: () => import("@/views/workbench/purchase/list.vue"),
        },
        {
            path: "addPurchase",
            meta: {
                title: "申请采购",
                permissionCode: "pcWorkbenchAddPurchase",
                state: "add",
                name: "pcWorkbenchAddPurchase",
                keepAlive: true
            },
            component: () => import("@/views/workbench/purchase/detail.vue"),
        },
        {
            path: "editPurchase",
            meta: {
                title: "修改申请采购",
                permissionCode: "pcWorkbenchAddPurchase",
                state: "edit",
                name: "pcWorkbenchAddPurchase",
                keepAlive: true
            },
            component: () => import("@/views/workbench/purchase/detail.vue"),
        },
        {
            path: "authPurchase",
            meta: {
                title: "审核申请采购",
                permissionCode: "pcWorkbenchAddPurchase",
                state: "auth",
                name: "pcWorkbenchAddPurchase",
                keepAlive: true
            },
            component: () => import("@/views/workbench/purchase/detail.vue"),
        },
        {
            path: "canApplyPurchase",
            meta: {
                title: "重新申请采购",
                permissionCode: "pcWorkbenchAddPurchase",
                state: "canApply",
                name: "pcWorkbenchAddPurchase",
                keepAlive: true

            },
            component: () => import("@/views/workbench/purchase/detail.vue"),
        },
        {
            path: "contractList",
            meta: {
                title: "合同管理",
                permissionCode: "pcWorkbenchContract",
                keepAlive: true,
                name: "contractList"
            },
            component: () => import("@/views/workbench/contract/list.vue"),
        },

        /****************************************************************
         *
         *@业主合同
         *
         ***************************************************************/
        {
            path: "addOwner",
            meta: {
                title: "业主合同申请",
                permissionCode: "pcWorkbenchOwnerContractDetail",
                state: "add",
                keepAlive: true,
                name: "ownerContract"
            },
            component: () => import("@/views/workbench/contract/owner/detail.vue"),
        },
        {
            path: "editOwner",
            meta: {
                title: "业主合同申请修改",
                permissionCode: "pcWorkbenchOwnerContractDetail",
                state: "edit",
                keepAlive: true,
                name: "ownerContract"
            },
            component: () => import("@/views/workbench/contract/owner/detail.vue"),
        },
        {
            path: "authOwner",
            meta: {
                title: "业主合同审批",
                permissionCode: "pcWorkbenchOwnerContractAuth",
                state: "auth",
                keepAlive: true,
                name: "ownerContract"
            },
            component: () => import("@/views/workbench/contract/owner/detail.vue"),
        },
        {
            path: "canApplyOwner",
            meta: {
                title: "业主合同重新申请",
                permissionCode: "pcWorkbenchOwnerContractDetail",
                state: "canApply",
                keepAlive: true,
                name: "ownerContract"
            },
            component: () => import("@/views/workbench/contract/owner/detail.vue"),
        },

        /****************************************************************
         *
         *@劳务合同
         *
         ***************************************************************/
        {
            path: "addLabour",
            meta: {
                title: "劳务合同申请",
                permissionCode: "pcWorkbenchLabourContractDetail",
                state: "add",
                keepAlive: true,
                name: "labourContract"
            },
            component: () => import("@/views/workbench/contract/labour/detail.vue"),
        },
        {
            path: "editLabour",
            meta: {
                title: "劳务合同申请修改",
                permissionCode: "pcWorkbenchLabourContractDetail",
                state: "edit",
                keepAlive: true,
                name: "labourContract"
            },
            component: () => import("@/views/workbench/contract/labour/detail.vue"),
        },
        {
            path: "authLabour",
            meta: {
                title: "劳务合同申请审批",
                permissionCode: "pcWorkbenchLabourContractAuth",
                state: "auth",
                keepAlive: true,
                name: "labourContract"
            },
            component: () => import("@/views/workbench/contract/labour/detail.vue"),
        },
        {
            path: "canApplyLabour",
            meta: {
                title: "劳务合同重新申请",
                permissionCode: "pcWorkbenchLabourContractDetail",
                state: "canApply",
                keepAlive: true,
                name: "labourContract"
            },
            component: () => import("@/views/workbench/contract/labour/detail.vue"),
        },
        /****************************************************************
         *
         *@劳务单包合同
         *
         ***************************************************************/
        {
            path: "addSingleLabour",
            meta: {
                title: "劳务单包合同申请",
                permissionCode: "pcWorkbenchLabourContractDetail",
                state: "add",
                keepAlive: true,
                name: "labourContract"
            },
            component: () => import("@/views/workbench/contract/singleLabour/detail.vue"),
        },
        {
            path: "editSingleLabour",
            meta: {
                title: "劳务单包合同申请修改",
                permissionCode: "pcWorkbenchLabourContractDetail",
                state: "edit",
                keepAlive: true,
                name: "labourContract"
            },
            component: () => import("@/views/workbench/contract/singleLabour/detail.vue"),
        },
        {
            path: "authSingleLabour",
            meta: {
                title: "劳务单包合同申请审批",
                permissionCode: "pcWorkbenchLabourContractAuth",
                state: "auth",
                keepAlive: true,
                name: "labourContract"
            },
            component: () => import("@/views/workbench/contract/singleLabour/detail.vue"),
        },
        {
            path: "canApplySingleLabour",
            meta: {
                title: "劳务单包合同重新申请",
                permissionCode: "pcWorkbenchLabourContractDetail",
                state: "canApply",
                keepAlive: true,
                name: "labourContract"
            },
            component: () => import("@/views/workbench/contract/singleLabour/detail.vue"),
        },
        /****************************************************************
         *
         *@劳务双包包合同
         *
         ***************************************************************/
        {
            path: "addDoubleLabour",
            meta: {
                title: "劳务双包合同申请",
                permissionCode: "pcWorkbenchLabourContractDetail",
                state: "add",
                keepAlive: true,
                name: "labourContract"
            },
            component: () => import("@/views/workbench/contract/doubleLabour/detail.vue"),
        },
        {
            path: "editDoubleLabour",
            meta: {
                title: "劳务双包合同申请修改",
                permissionCode: "pcWorkbenchLabourContractDetail",
                state: "edit",
                keepAlive: true,
                name: "labourContract"
            },
            component: () => import("@/views/workbench/contract/doubleLabour/detail.vue"),
        },
        {
            path: "authDoubleLabour",
            meta: {
                title: "劳务双包包合同申请审批",
                permissionCode: "pcWorkbenchLabourContractAuth",
                state: "auth",
                keepAlive: true,
                name: "labourContract"
            },
            component: () => import("@/views/workbench/contract/doubleLabour/detail.vue"),
        },
        {
            path: "canApplyDoubleLabour",
            meta: {
                title: "劳务双包合同重新申请",
                permissionCode: "pcWorkbenchLabourContractDetail",
                state: "canApply",
                keepAlive: true,
                name: "labourContract"
            },
            component: () => import("@/views/workbench/contract/doubleLabour/detail.vue"),
        },
        /****************************************************************
         *
         *@专项分包合同
         *
         ***************************************************************/
        {
            path: "addSpecially",
            meta: {
                title: "专项分包合同申请",
                permissionCode: "pcWorkbenchSpeciallyContractDetail",
                state: "add",
                keepAlive: true,
                name: "speciallyContract"
            },
            component: () => import("@/views/workbench/contract/specially/detail.vue"),
        },
        {
            path: "editSpecially",
            meta: {
                title: "专项分包合同申请修改",
                permissionCode: "pcWorkbenchSpeciallyContractDetail",
                state: "edit",
                keepAlive: true,
                name: "speciallyContract"
            },
            component: () => import("@/views/workbench/contract/specially/detail.vue"),
        },
        {
            path: "authSpecially",
            meta: {
                title: "专项分包包合同申请审批",
                permissionCode: "pcWorkbenchSpeciallyContractAuth",
                state: "auth",
                keepAlive: true,
                name: "speciallyContract"
            },
            component: () => import("@/views/workbench/contract/specially/detail.vue"),
        },
        {
            path: "canApplySpecially",
            meta: {
                title: "专项分包合同重新申请",
                permissionCode: "pcWorkbenchSpeciallyContractDetail",
                state: "canApply",
                keepAlive: true,
                name: "speciallyContract"
            },
            component: () => import("@/views/workbench/contract/specially/detail.vue"),
        },



        /****************************************************************
         *
         *@材料合同
         *
         ***************************************************************/
        {
            path: "addMaterial",
            meta: {
                title: "材料单包合同申请",
                permissionCode: "pcWorkbenchMaterialContractDetail",
                state: "add",
                keepAlive: true,
                name: "materialContract"
            },
            component: () => import("@/views/workbench/contract/material/detail.vue"),
        },
        {
            path: "editMaterial",
            meta: {
                title: "材料单包合同申请修改",
                permissionCode: "pcWorkbenchMaterialContractDetail",
                state: "edit",
                keepAlive: true,
                name: "materialContract"
            },
            component: () => import("@/views/workbench/contract/material/detail.vue"),
        },
        {
            path: "canApplyMaterial",
            meta: {
                title: "材料单包合同重新申请",
                permissionCode: "pcWorkbenchMaterialContractDetail",
                state: "canApply",
                keepAlive: true,
                name: "materialContract"
            },
            component: () => import("@/views/workbench/contract/material/detail.vue"),
        },
        {
            path: "authMaterial",
            meta: {
                title: "材料单包合同申请审批",
                permissionCode: "pcWorkbenchMaterialContractAuth",
                state: "auth",
                keepAlive: true,
                name: "materialContract"
            },
            component: () => import("@/views/workbench/contract/material/detail.vue"),
        },

        /****************************************************************
         *
         *@双包合同
         *
         ***************************************************************/
        {
            path: "addDouble",
            meta: {
                title: "材料双包合同申请",
                permissionCode: "pcWorkbenchDoubleContractDetail",
                state: "add",
                keepAlive: true,
                name: "doubleContract"
            },
            component: () => import("@/views/workbench/contract/double/detail.vue"),
        },
        {
            path: "editDouble",
            meta: {
                title: "材料双包合同申请修改",
                permissionCode: "pcWorkbenchDoubleContractDetail",
                state: "edit",
                keepAlive: true,
                name: "doubleContract"
            },
            component: () => import("@/views/workbench/contract/double/detail.vue"),
        },
        {
            path: "authDouble",
            meta: {
                title: "材料双包合同申请审批",
                permissionCode: "pcWorkbenchDoubleContractAuth",
                state: "auth",
                keepAlive: true,
                name: "doubleContract"
            },
            component: () => import("@/views/workbench/contract/double/detail.vue"),
        },
        {
            path: "canApplyDouble",
            meta: {
                title: "材料双包合同重新审批",
                permissionCode: "pcWorkbenchDoubleContractDetail",
                state: "canApply",
                keepAlive: true,
                name: "doubleContract"
            },
            component: () => import("@/views/workbench/contract/double/detail.vue"),
        },


        /****************************************************************
         *
         *@一般合同
         *
         ***************************************************************/
        {
            path: "addCommon",
            meta: {
                title: "一般合同申请",
                permissionCode: "pcWorkbenchCommonContractDetail",
                state: "add",
                keepAlive: true,
                name: "commonContract"
            },
            component: () => import("@/views/workbench/contract/common/detail.vue"),
        },
        {
            path: "editCommon",
            meta: {
                title: "一般合同申请修改",
                permissionCode: "pcWorkbenchCommonContractDetail",
                state: "edit",
                keepAlive: true,
                name: "commonContract"
            },
            component: () => import("@/views/workbench/contract/common/detail.vue"),
        },
        {
            path: "authCommon",
            meta: {
                title: "一般合同申请审批",
                permissionCode: "pcWorkbenchCommonContractAuth",
                state: "auth",
                keepAlive: true,
                name: "commonContract"
            },
            component: () => import("@/views/workbench/contract/common/detail.vue")
        },
        {
            path: "canApplyCommon",
            meta: {
                title: "一般合同重新申请",
                permissionCode: "pcWorkbenchCommonContractDetail",
                state: "canApply",
                keepAlive: true,
                name: "commonContract"
            },
            component: () => import("@/views/workbench/contract/common/detail.vue")
        },

        /****************************************************************
         *
         *@付款申请
         *
         ***************************************************************/
        {
            path: "payment",
            meta: {
                title: "付款申请",
                permissionCode: "pcWorkbenchPayment",
                name: "workbenchPayment",
                keepAlive: true
            },
            component: () => import("@/views/workbench/payment/list.vue"),
        },

        /****************************************************************
         *
         *@奖惩管理
         *
         ***************************************************************/
        {
            path: "penalize",
            meta: { 
                title: "奖惩管理",
                permissionCode: "pcWorkbenchPenalize",
                name: "pcWorkbenchPenalize",
                keepAlive: true
            },
            component: () => import("@/views/workbench/penalize/list.vue"),
        },

        /****************************************************************
         *
         *@开票申请
         *
         ***************************************************************/
        {
            path: "billingList",
            meta: {
                title: "开票申请",
                permissionCode: "pcWorkbenchBillingList",
                name: "pcWorkbenchBillingList",
                keepAlive: true
            },
            component: () => import("@/views/workbench/billing/list.vue"),
        },
        {
            path: "billing/create",
            meta: {
                title: "开票申请新增/编辑",
                permissionCode: "pcWorkbenchBillingDetail",
                keepAlive: true,
                name: "pcWorkbenchBilling"
            },
            component: () => import("@/views/workbench/billing/details.vue"),
        },
        {
            path: "billing/canApplyCreate",
            meta: {
                title: "开票重新申请",
                permissionCode: "pcWorkbenchBillingDetail",
                keepAlive: true,
                name: "pcWorkbenchBilling"
            },
            component: () => import("@/views/workbench/billing/details.vue"),
        },
        {
            path: "billing/auth",
            meta: {
                title: "开票申请审批",
                permissionCode: "pcWorkbenchBillingAuth",
                keepAlive: true,
                name: "pcWorkbenchBillingAuth"
            },
            component: () => import("@/views/workbench/billing/auth.vue"),
        },
        /****************************************************************
         *
         *@用章申请
         *
         ***************************************************************/
        {
            path: "sealList",
            meta: {
                title: "用章申请",
                permissionCode: "pcWorkbenchSealList",
                name: "pcWorkbenchSealList",
                keepAlive: true
            },
            component: () => import("@/views/workbench/sealManage/list.vue"),
        },
        {
            path: "sealManage/create",
            meta: {
                title: "用章申请新增/编辑",
                permissionCode: "pcWorkbenchSealEdit",
                name: "pcWorkbenchSealDetail",
                keepAlive: true
            },
            component: () => import("@/views/workbench/sealManage/details.vue"),
        },
        {
            path: "sealManage/canApplyCreate",
            meta: {
                title: "用章重新申请",
                permissionCode: "pcWorkbenchSealEdit",
                name: "pcWorkbenchSealDetail",
                keepAlive: true
            },
            component: () => import("@/views/workbench/sealManage/details.vue"),
        },
        {
            path: "sealManage/auth",
            meta: {
                title: "用章申请审批",
                permissionCode: "pcWorkbenchSealAuth",
            },
            component: () => import("@/views/workbench/sealManage/auth.vue"),
        },
        {
            path: "workWeekly/list",
            meta: {
                title: "工作周报",
                permissionCode: "pcWorkbenchWorkWeeklyList",
                name: "pcWorkbenchWorkWeeklyList",
                keepAlive: true
            },
            component: () => import("@/views/workbench/workWeekly/list.vue"),
        },
        {
            path: "workWeekly/details",
            meta: {
                title: "填写工作周报",
                permissionCode: "pcWorkbenchWorkWeeklyDetail",
                keepAlive: true,
                name: "pcWorkbenchWorkWeeklyDetail"
            },
            component: () => import("@/views/workbench/workWeekly/details.vue"),
        },
        {
            path: "workWeekly/review",
            meta: {
                title: "工作周报",
                permissionCode: "pcWorkbenchWorkWeeklyAuth",
            },
            component: () => import("@/views/workbench/workWeekly/review.vue"),
        },
        /****************************************************************
         *
         *@借款申请
         *
         ***************************************************************/
        {
            path: "loan/list",
            meta: {
                title: "借款申请列表",
                permissionCode: "pcWorkbenchLoan",
                name: "pcWorkbenchLoan",
                keepAlive: true
            },
            component: () => import("@/views/workbench/loan/list.vue"),
        },
        {
            path: "loan/apply",
            meta: {
                title: "借款申请新增/修改",
                permissionCode: "pcWorkbenchLoanEdit",
                name: "pcWorkbenchLoanForm",
                keepAlive: true
            },
            component: () => import("@/views/workbench/loan/add.vue"),
        },
        {
            path: "loan/auth",
            meta: {
                title: "借款申请审核",
                permissionCode: "pcWorkbenchLoanAuth",
            },
            component: () => import("@/views/workbench/loan/auth.vue"),
        },
        /****************************************************************
         *
         *@报销申请
         *
         ***************************************************************/
        {
            path: "reimbursement/list",
            meta: {
                title: "报销申请列表",
                permissionCode: "pcWorkbenchReimbursement",
                name: "pcWorkbenchReimbursement",
                keepAlive: true
            },
            component: () => import("@/views/workbench/reimbursement/list.vue"),
        },
        {
            path: "reimbursement/apply",
            meta: {
                title: "报销申请新增/修改",
                permissionCode: "pcWorkbenchReimbursementEdit",
                name: "pcWorkbenchReimbursementForm",
                keepAlive: true
            },
            component: () => import("@/views/workbench/reimbursement/add.vue"),
        },
        {
            path: "reimbursement/auth",
            meta: {
                title: "报销申请审核",
                permissionCode: "pcWorkbenchReimbursementAuth",
            },
            component: () => import("@/views/workbench/reimbursement/auth.vue"),
        },
        /****************************************************************
         *
         *@材料询价
         *
         ***************************************************************/
        {
            path: "inquiry/list",
            meta: {
                title: "材料询价列表",
                permissionCode: "pcWorkbenchInquiry",
                name: "workbenchInquiry",
                keepAlive: true
            },
            component: () => import("@/views/workbench/inquiry/list.vue"),
        },
        {
            path: "inquiry/apply",
            meta: {
                title: "材料询价新增/修改",
                permissionCode: "pcWorkbenchInquiryEdit",
                name: "pcWorkbenchInquiryForm",
                keepAlive: true
            },
            component: () => import("@/views/workbench/inquiry/add.vue"),
        },
        {
            path: "inquiry/auth",
            meta: {
                title: "材料询价审核",
                permissionCode: "pcWorkbenchInquiryAuth",
            },
            component: () => import("@/views/workbench/inquiry/auth.vue"),
        },
        /****************************************************************
         *
         *@请假申请
         *
         ***************************************************************/
        {
            path: "leaveManage/list",
            meta: {
                title: "请假申请列表",
                permissionCode: "pcWorkbenchLeaveManage",
                name: "pcWorkbenchLeaveManage",
                keepAlive: true
            },
            component: () => import("@/views/workbench/leaveManage/list.vue"),
        },
        {
            path: "leaveManage/details",
            meta: {
                title: "请假申请新增/修改",
                permissionCode: "pcWorkbenchLeaveManageEdit",
                name: "pcWorkbenchLeaveManageForm",
                keepAlive: true
            },
            component: () => import("@/views/workbench/leaveManage/details.vue"),
        }, {
            path: "leaveManage/canApplyCreate",
            meta: {
                title: "重新申请请假申请",
                permissionCode: "pcWorkbenchLeaveManageEdit",
                name: "pcWorkbenchLeaveManageForm",
                keepAlive: true
            },
            component: () => import("@/views/workbench/leaveManage/details.vue"),
        },
        {
            path: "leaveManage/auth",
            meta: {
                title: "请假申请审核",
                permissionCode: "pcWorkbenchLeaveManageAuth",
            },
            component: () => import("@/views/workbench/leaveManage/auth.vue"),
        },
        /****************************************************************
         *
         *@出差申请
         *
         ***************************************************************/
        {
            path: "travelManage/list",
            meta: {
                title: "出差申请列表",
                permissionCode: "pcWorkbenchTravelManage",
                name: "pcWorkbenchTravelManage",
                keepAlive: true
            },
            component: () => import("@/views/workbench/travelManage/list.vue"),
        },
        {
            path: "travelManage/details",
            meta: {
                title: "出差申请新增/修改",
                permissionCode: "pcWorkbenchTravelManageEdit",
                name: "pcWorkbenchTravelManageForm",
                keepAlive: true
            },
            component: () => import("@/views/workbench/travelManage/details.vue"),
        },
        {
            path: "travelManage/canApplyCreate",
            meta: {
                title: "重新申请出差申请",
                permissionCode: "pcWorkbenchTravelManageEdit",
                name: "pcWorkbenchTravelManageForm",
                keepAlive: true
            },
            component: () => import("@/views/workbench/travelManage/details.vue"),
        },
        {
            path: "travelManage/auth",
            meta: {
                title: "出差申请审核",
                permissionCode: "pcWorkbenchTravelManageAuth",
            },
            component: () => import("@/views/workbench/travelManage/auth.vue"),
        },
        /****************************************************************
         *
         *@通用流程申请
         *
         ***************************************************************/
        {
            path: "commonManage/list",
            meta: {
                title: "通用流程列表",
                permissionCode: "pcWorkbenchCommonManage",
                name: "pcWorkbenchCommonManage",
                keepAlive: true
            },
            component: () => import("@/views/workbench/commonManage/list.vue"),
        },
        {
            path: "commonManage/details",
            meta: {
                title: "通用流程申请新增/修改",
                permissionCode: "pcWorkbenchCommonManageEdit",
                name: "pcWorkbenchCommonManageForm",
                keepAlive: true
            },
            component: () => import("@/views/workbench/commonManage/details.vue"),
        },
        {
            path: "commonManage/canApplyCreate",
            meta: {
                title: "重新申请通用流程",
                permissionCode: "pcWorkbenchCommonManageEdit",
                name: "pcWorkbenchCommonManageForm",
                keepAlive: true
            },
            component: () => import("@/views/workbench/commonManage/details.vue"),
        },
        {
            path: "commonManage/auth",
            meta: {
                title: "通用流程审核",
                permissionCode: "pcWorkbenchCommonManageAuth",
            },
            component: () => import("@/views/workbench/commonManage/auth.vue"),
        },
        /****************************************************************
         *
         *@办公用品领用申请
         *
         ***************************************************************/
         {
            path: "officeUse/list",
            meta: {
                title: "办公用品领用申请",
                permissionCode: "pcWorkbenchOfficeUse",
                name:"pcWorkbenchOfficeUse",
                keepAlive: true
            },
            component: () => import("@/views/workbench/officeUse/list.vue"),
        },
        {
            path: "officeUse/details",
            meta: {
                title: "办公用品领用申请新增/修改",
                permissionCode: "pcWorkbenchOfficeUseEdit",
                name:"pcWorkbenchOfficeUseForm",
                keepAlive: true
            },
            component: () => import("@/views/workbench/officeUse/details.vue"),
        },
        {
            path: "officeUse/canApplyCreate",
            meta: {
                title: "重新申请办公用品领用",
                permissionCode: "pcWorkbenchOfficeUseEdit",
                name:"pcWorkbenchOfficeUseForm",
                keepAlive: true
            },
            component: () => import("@/views/workbench/officeUse/details.vue"),
        },
        {
            path: "officeUse/auth",
            meta: {
                title: "办公用品领用申请审核",
                permissionCode: "pcWorkbenchOfficeUseAuth",
            },
            component: () => import("@/views/workbench/officeUse/auth.vue"),
        },
        /****************************************************************
         *
         *@办公用品采购申请
         *
         ***************************************************************/
        {
            path: "officePurchase/list",
            meta: {
                title: "办公用品采购申请",
                permissionCode: "pcWorkbenchOfficePurchase",
                keepAlive: true,
                name: "pcWorkbenchOfficePurchase"
            },
            component: () => import("@/views/workbench/officePurchase/list.vue"),
        },
        {
            path: "officePurchase/details",
            meta: {
                title: "办公用品采购申请新增/修改",
                permissionCode: "pcWorkbenchOfficePurchaseEdit",
                keepAlive: true,
                name: "pcWorkbenchOfficePurchaseForm"
            },
            component: () => import("@/views/workbench/officePurchase/details.vue"),
        },
        {
            path: "officePurchase/canApplyCreate",
            meta: {
                title: "重新申请办公用品采购",
                permissionCode: "pcWorkbenchOfficePurchaseEdit",
                keepAlive: true,
                name: "pcWorkbenchOfficePurchaseForm"
            },
            component: () => import("@/views/workbench/officePurchase/details.vue"),
        },
        {
            path: "officePurchase/auth",
            meta: {
                title: "办公用品采购申请审核",
                permissionCode: "pcWorkbenchOfficePurchaseAuth",
            },
            component: () => import("@/views/workbench/officePurchase/auth.vue"),
        },
        /****************************************************************
         *
         *@甲供材料结算申请
         *
         ***************************************************************/
        {
            path: "partASettle/list",
            meta: {
                title: "甲供材料结算申请",
                permissionCode: "pcWorkbenchPartASettle",
                keepAlive: true,
                name: "pcWorkbenchPartASettle"
            },
            component: () => import("@/views/workbench/partASettle/list.vue"),
        },
        {
            path: "partASettle/add",
            meta: {
                title: "甲供材料结算新增",
                permissionCode: "pcWorkbenchPartASettleEdit",
                state: "add",
                keepAlive: true,
                name: "pcWorkbenchPartASettleForm"
            },
            component: () => import("@/views/workbench/partASettle/detail.vue"),
        },
        {
            path: "partASettle/edit",
            meta: {
                title: "甲供材料结算修改",
                permissionCode: "pcWorkbenchPartASettleEdit",
                state:'edit',
                keepAlive: true,
                name: "pcWorkbenchPartASettleForm"
            },
            component: () => import("@/views/workbench/partASettle/detail.vue"),
        },
        {
            path: "partASettle/canApplyCreate",
            meta: {
                title: "重新申请甲供材料结算",
                permissionCode: "pcWorkbenchPartASettleEdit",
                keepAlive: true,
                state:'canApply',
                name: "pcWorkbenchPartASettleForm"
            },
            component: () => import("@/views/workbench/partASettle/detail.vue"),
        },
        {
            path: "partASettle/auth",
            meta: {
                title: "甲供材料结算审核",
                permissionCode: "pcWorkbenchPartASettleAuth",
                state:'auth',
                keepAlive: true,
                name: "pcWorkbenchPartASettleForm",
            },
            component: () => import("@/views/workbench/partASettle/detail.vue"),
        },

    ],
};
